import { Pagination, Stack } from "@mui/material";
import { theme } from "../../theme";

const PaginationView = ({ totalPages, page, onPageChange }) => {
    if (!totalPages) return null;

    return (
        <Stack
            spacing={2}
            className="mb-3"
            sx={{
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Pagination
                count={totalPages}
                page={page}
                onChange={(e, value) => onPageChange(value)}
                color={theme.main}
            />
        </Stack>
    );
};

export default PaginationView;